// Icons
import {
  MenuBook as Booked,
  QuestionMark as Unknown,
  DriveFileMove as Moved,
  Check as Completed,
  Close as Cancelled,
} from "@mui/icons-material";

// Constants
import {
  APPOINTMENT_STATUS,
  BOOKED_STATUS,
  MOVED_STATUS,
  CANCELLED_STATUS,
} from "Constants/AppointmentConstants";

const createStatusConfig = (Icon, colour, showActions) => ({
  Icon,
  colour,
  showActions,
});

export const getAppointmentStatusConfig = (theme) => ({
  ...Object.fromEntries(
    BOOKED_STATUS.map((status) => [
      status,
      createStatusConfig(Booked, theme.palette.info.main, true),
    ])
  ),
  ...Object.fromEntries(
    MOVED_STATUS.map((status) => [
      status,
      createStatusConfig(Moved, theme.palette.warning.main, true),
    ])
  ),
  ...Object.fromEntries(
    CANCELLED_STATUS.map((status) => [
      status,
      createStatusConfig(Cancelled, theme.palette.error.main, false),
    ])
  ),
  [APPOINTMENT_STATUS.Completed]: createStatusConfig(
    Completed,
    theme.palette.success.main,
    false
  ),
  [APPOINTMENT_STATUS.Unknown]: createStatusConfig(
    Unknown,
    theme.palette.text.primary,
    false
  ),
});
